import { useApp } from "../../state/store";
import { useT } from "../../i18n/store";
import type { CutStyle } from "../../domain/types";
import { Section } from "../Section";
import { NumberInput } from "../NumberInput";
import { Checkbox } from "../Checkbox";

export const CutGuidesSection = () => {
  const t = useT();
  const cut = useApp((s) => s.cut);
  const setCut = useApp((s) => s.setCut);

  return (
    <Section title={t("section.cut")}>
      <div className="row check">
        <Checkbox
          label={t("cut.add")}
          checked={cut.enabled}
          onChange={(enabled) => setCut({ enabled })}
        />
      </div>
      <div className="row two">
        <div>
          <label>{t("cut.style")}</label>
          <select
            className="ctl"
            value={cut.style}
            onChange={(e) => setCut({ style: e.target.value as CutStyle })}
          >
            <option value="solid">{t("cut.style.solid")}</option>
            <option value="dashed">{t("cut.style.dashed")}</option>
            <option value="dotted">{t("cut.style.dotted")}</option>
          </select>
        </div>
        <div>
          <label>{t("cut.thickness")}</label>
          <NumberInput
            value={cut.thicknessMm}
            onChange={(thicknessMm) => setCut({ thicknessMm })}
            min={0.05} max={2} step={0.05}
            unit={t("unit.mm")}
          />
        </div>
      </div>
    </Section>
  );
};
